var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "padding-bottom-xl", attrs: { id: "hero" } },
    [
      _c(
        "div",
        {
          staticClass: "row align-middle position-relative",
          staticStyle: { "background-color": "var(--white)" },
        },
        [
          _c("icon-grid", {
            attrs: {
              "icon-class-matrix": _vm.iconClassMatrix,
              "primary-color": _vm.primaryColor,
              "color-transition": _vm.colorTransition,
              "grid-config": _vm.leftGridConfig,
              "current-family": _vm.currentFamilyStyle.family,
              "current-style": _vm.currentFamilyStyle.style,
              "current-pack-name": _vm.currentPackName,
              position: "left",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "text-center padding-xl column-8 laptop:column-4 desktop:column-3",
            },
            [
              _c(
                "span",
                {
                  staticClass: "display-block",
                  style: _vm.logoStyle,
                  attrs: {
                    role: "button",
                    tabindex: "0",
                    "aria-label": `${_vm.currentFamilyStyleLabel}!`,
                    "aria-describedby": "hero-randomize-desc",
                    "data-balloon-pos": "up",
                    "data-balloon-visible": _vm.isAutoRandomizing,
                  },
                  on: {
                    click: _vm.randomize,
                    keydown: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.randomize.apply(null, arguments)
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "space", 32, $event.key, [
                            " ",
                            "Spacebar",
                          ])
                        )
                          return null
                        $event.preventDefault()
                        return _vm.randomize.apply(null, arguments)
                      },
                    ],
                    mousedown: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c("i", {
                    class: _vm.logoIconClass,
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "sr-only",
                      attrs: { id: "hero-randomize-desc" },
                    },
                    [_vm._v("Click to randomize icon style")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("h1", { staticClass: "margin-top-xs margin-bottom-0" }, [
                _c("span", [
                  _c(
                    "span",
                    {
                      style: {
                        transition: _vm.colorTransition,
                        color: _vm.taglineColors.logo.text,
                      },
                    },
                    [_vm._v("Font Awesome")]
                  ),
                  _c(
                    "span",
                    {
                      style: {
                        transition: _vm.colorTransition,
                        color: _vm.taglineColors.logo.period,
                      },
                    },
                    [_vm._v(".")]
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      style: {
                        transition: _vm.colorTransition,
                        color: _vm.taglineColors.first.text,
                      },
                    },
                    [_vm._v("Icons")]
                  ),
                  _c(
                    "span",
                    {
                      style: {
                        transition: _vm.colorTransition,
                        color: _vm.taglineColors.first.period,
                      },
                    },
                    [_vm._v(".")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      style: {
                        transition: _vm.colorTransition,
                        color: _vm.taglineColors.second.text,
                      },
                    },
                    [_vm._v("Easy")]
                  ),
                  _c(
                    "span",
                    {
                      style: {
                        transition: _vm.colorTransition,
                        color: _vm.taglineColors.second.period,
                      },
                    },
                    [_vm._v(".")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      style: {
                        transition: _vm.colorTransition,
                        color: _vm.taglineColors.third.text,
                      },
                    },
                    [_vm._v("Done")]
                  ),
                  _c(
                    "span",
                    {
                      style: {
                        transition: _vm.colorTransition,
                        color: _vm.taglineColors.third.period,
                      },
                    },
                    [_vm._v(".")]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "size-lg margin-y-2xl text-wrap-balance" },
                [_vm._v("The internet's favorite icon library & toolkit.")]
              ),
              _vm._v(" "),
              _c(
                "form",
                {
                  staticClass:
                    "icons-search form line-length-sm padding-bottom-xl margin-auto",
                  staticStyle: { "--form-button-margin": "0" },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.search.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "with-icon-before",
                      staticStyle: {
                        "--input-with-icon-color": "var(--fa-navy)",
                        "--input-border-color": "var(--fa-navy)",
                        "--input-placeholder-color": "var(--fa-md-gravy)",
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        staticStyle: { "line-height": "1" },
                        attrs: { icon: _vm.$v7.solid.faMagnifyingGlass },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "sr-only",
                          attrs: { for: "icons-search" },
                        },
                        [_vm._v("\n            Search for Icons\n          ")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.query,
                            expression: "query",
                          },
                        ],
                        staticClass: "rounded",
                        attrs: {
                          id: "icons-search",
                          type: "text",
                          name: "icons-search",
                          placeholder: `Find the perfect icon...`,
                        },
                        domProps: { value: _vm.query },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.query = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        { staticClass: "sr-only", attrs: { type: "submit" } },
                        [_vm._v("\n            Search for Icons\n          ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "dl",
                {
                  staticClass:
                    "hero-stats margin-0 padding-0 display-flex flex-wrap flex-items-center flex-content-center",
                  style: {
                    gap: "var(--spacing-md)",
                    "--link-color": _vm.computedLinkColor,
                    transition: _vm.colorTransition,
                  },
                },
                [
                  _c("dt", { staticClass: "sr-only" }, [
                    _vm._v("About Font Awesome Icons"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "dd",
                    { staticClass: "size-sm margin-bottom-0" },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "margin-right-3xs",
                        attrs: { icon: _vm.$v7.solid.faHashtag, size: "lg" },
                      }),
                      _vm._v(" "),
                      _c(
                        "site-link",
                        { attrs: { to: { name: "changelog" } } },
                        [_vm._v("v" + _vm._s(_vm.$releases.active.version))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "dd",
                    { staticClass: "size-sm margin-bottom-0" },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "margin-right-3xs",
                        attrs: { icon: _vm.$v7.solid.faShapes, size: "lg" },
                      }),
                      _vm._v(" "),
                      _c("site-link", { attrs: { to: _vm.$search() } }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$counts.icons.all.formatted) +
                            " Icons "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "dd",
                    { staticClass: "size-sm margin-bottom-0" },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "margin-right-3xs",
                        attrs: { icon: _vm.$v7.solid.faPalette, size: "lg" },
                      }),
                      _vm._v(" "),
                      _c("site-link", { attrs: { to: _vm.$icons() } }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$counts.totalLatestStylesWithoutBrands) +
                            " Icon Styles "
                        ),
                      ]),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("icon-grid", {
            attrs: {
              "icon-class-matrix": _vm.iconClassMatrix,
              "primary-color": _vm.primaryColor,
              "color-transition": _vm.colorTransition,
              "grid-config": _vm.rightGridConfig,
              "current-family": _vm.currentFamilyStyle.family,
              "current-style": _vm.currentFamilyStyle.style,
              "current-pack-name": _vm.currentPackName,
              position: "right",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container padding-top-4xl",
          attrs: { id: "fa7-video" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "row align-bottom laptop:align-top padding-bottom-lg roomy position-relative",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "column-12 laptop:column-8 padding-bottom-lg laptop:padding-bottom-0",
                },
                [
                  _c("div", { style: _vm.videoContainerStyle }, [
                    _vm.isVimeoAllowed
                      ? _c("iframe", {
                          staticStyle: {
                            position: "absolute",
                            top: "0",
                            left: "0",
                            width: "100%",
                            height: "100%",
                          },
                          attrs: {
                            src: _vm.videoUrl,
                            title: "Font Awesome product overview video",
                            frameborder: "0",
                            webkitAllowFullScreen: "",
                            mozallowfullscreen: "",
                            allowFullScreen: "",
                          },
                        })
                      : _c(
                          "a",
                          { attrs: { href: _vm.videoUrl, target: "_blank" } },
                          [
                            _c("img", {
                              staticStyle: {
                                position: "absolute",
                                top: "0",
                                left: "0",
                                width: "100%",
                                height: "100%",
                              },
                              attrs: {
                                src: _vm.placeholderImage,
                                frameborder: "0",
                              },
                            }),
                          ]
                        ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "column-8 offset-2 tablet:column-8 tablet:offset-2 laptop:column-4 laptop:offset-0 padding-top-4xl laptop:padding-top-0",
                },
                [_c("sale-cta")],
                1
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }